import { Switch as SwitchPrimitives } from "radix-ui";
import React from "react";

import { cn } from "~/components/ui/cn";
import { CheckIcon } from "~/components/ui/icons/check";
import { CloseIcon } from "~/components/ui/icons/close";

export type ToggleSwitchProps = {
  defaultChecked?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void | undefined;
  value?: string;
};

export const ToggleSwitch: React.FC<
  React.ComponentProps<typeof SwitchPrimitives.Root>
> = ({ className, ...props }) => (
  <SwitchPrimitives.Root
    className={cn(
      "relative inline-flex h-7 w-10 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-300 transition-colors duration-100 ease-in-out focus:outline focus:outline-gray-400/20 disabled:cursor-not-allowed disabled:bg-gray-50 data-[state=checked]:bg-green-900 data-[state=checked]:focus:outline-green-900/20 data-[state=checked]:disabled:bg-gray-100",
      className,
    )}
    {...props}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        "group pointer-events-none inline-block size-6 rounded-full bg-white text-gray-300 shadow-sm ring-0 transition duration-100 ease-in-out data-[state=checked]:translate-x-3 data-[state=unchecked]:translate-x-0 data-[disabled]:text-gray-100 data-[state=checked]:text-green-900",
      )}
    >
      <CheckIcon className="absolute left-1 top-1 hidden size-4 group-data-[state=checked]:block" />
      <CloseIcon className="absolute left-1 top-1 hidden size-4 group-data-[state=unchecked]:block" />
    </SwitchPrimitives.Thumb>
  </SwitchPrimitives.Root>
);

ToggleSwitch.displayName = "ToggleSwitch";
